import { render, staticRenderFns } from "./ShowUser.vue?vue&type=template&id=448b72fa&scoped=true&"
import script from "./ShowUser.vue?vue&type=script&lang=js&"
export * from "./ShowUser.vue?vue&type=script&lang=js&"
import style0 from "./ShowUser.vue?vue&type=style&index=0&id=448b72fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448b72fa",
  null
  
)

export default component.exports